module.exports = __webpack_public_path__ + "img/smw-library06.8d19de87.jpg";